export const columnLayout = [
  {
    dataField: "cameraGuid",
    headerText: "카메라GUID",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "cameraNm",
    headerText: "카메라명",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "scrapAreaCd",
    headerText: "하차구역",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "scrapAreaNm",
    headerText: "하차구역명",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "cameraIp",
    headerText: "카메라IP",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "rtspAddr",
    headerText: "RTSP주소",
    width: 300,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "cameraPort",
    headerText: "카메라포트",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "snapshotPrd",
    headerText: "스냅샷주기",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "milestoneNm",
    headerText: "마일스톤명",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "sortSeq",
    headerText: "정렬순서",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "serverIp",
    headerText: "중계서버IP",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "bitrate",
    headerText: "전송속도",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "frame",
    headerText: "영상프레임수",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "resolution",
    headerText: "영상해상도",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "recYn",
    headerText: "녹화여부",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
    editRenderer: {
      type: "ComboBoxRenderer",
      autoCompleteMode: true, // 자동완성 모드 설정
      matchFromFirst: false, // 처음부터 매치가 아닌 단순 포함되는 자동완성
      list: [
        { code: "Y", value: "사용" },
        { code: "N", value: "미사용" },
      ], //key-value Object 로 구성된 리스트
      keyField: "code", // key 에 해당되는 필드명
      valueField: "value", // value 에 해당되는 필드명
    },
  },
  {
    dataField: "useYn",
    headerText: "사용여부",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
    editRenderer: {
      type: "ComboBoxRenderer",
      autoCompleteMode: true, // 자동완성 모드 설정
      matchFromFirst: false, // 처음부터 매치가 아닌 단순 포함되는 자동완성
      list: [
        { code: "Y", value: "사용" },
        { code: "N", value: "미사용" },
      ], //key-value Object 로 구성된 리스트
      keyField: "code", // key 에 해당되는 필드명
      valueField: "value", // value 에 해당되는 필드명
    },
  },
];
